import pathfinder from '@fiverr-private/pathfinder';
import { PATHS, PATHFINDER } from '../constants';
import { formatQueryParams, getCategorySlug } from '../helperFunctions';
import type { MapperItemConfig } from './types';

export const getCategoryPath = ({ id, queryParams, source }: MapperItemConfig) => {
    if (!id) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(id, 10))) {
        return PATHS.ROOT;
    }

    const params = { id: getCategorySlug(id) };

    return pathfinder(PATHFINDER.CATEGORY, params, formatQueryParams({ queryParams, source }));
};
